<div class="appointment-window-modal">
  <div class="modal-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fa-solid fa-calendar-check"></i>
      </div>
      <div class="header-copy">
        <h2>{{ dialogTitle }}</h2>
        <p>{{ orderLabel }}</p>
      </div>
    </div>
  </div>

  <div class="modal-body">
    <div class="window-grid">
      <label class="window-field">
        <span>Window Start</span>
        <input type="datetime-local" step="60" [(ngModel)]="startValue" />
      </label>

      <label class="window-field">
        <span>Window End</span>
        <input type="datetime-local" step="60" [(ngModel)]="endValue" />
      </label>
    </div>

    <div class="validation-banner" *ngIf="!isValid">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <span>{{ validationMessage }}</span>
    </div>
  </div>

  <div class="modal-actions">
    <button type="button" class="btn btn-ghost" (click)="clearWindow()" [disabled]="saving">
      Clear Window
    </button>

    <div class="action-group">
      <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="saving">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" (click)="saveWindow()" [disabled]="!isValid || saving">
        <i class="fa-solid fa-check" *ngIf="!saving"></i>
        {{ saving ? 'Saving...' : 'Save Window' }}
      </button>
    </div>
  </div>
</div>
